// See here for a better error handling approach with await functions : https://dev.to/sobiodarlington/better-error-handling-with-async-await-2e5m

export const to = promise =>
  promise.then(data => [data, null]).catch(err => [{}, err]);
